// extracted by mini-css-extract-plugin
export var stepActive = "_2n-3";
export var stepCompleted = "_2n-4";
export var stepConnectorLine = "_2n-b";
export var stepIndicatorCircle = "_2n-6";
export var stepIndicatorCircleCompleted = "_2n-7";
export var stepIndicatorCircleDefault = "_2n-8";
export var stepIndicatorTextCompleted = "_2n-9";
export var stepIndicatorTextDefault = "_2n-a";
export var stepPending = "_2n-5";
export var wizardContainer = "_2n-1";
export var wizardContent = "_2n-2";
export var wizardModal = "_2n-0";